import { call, put, takeLatest } from 'redux-saga/effects' 
import { PROFILE_UPDATE_API_CALL, MYASSIGNMENT_GET_API_CALL, MYASSIGNMENT_RECEIVE_DATA_API, NOTES_STORE_API_CALL } from '../Actions/actionTypes'
import { profileUpdate, myAssignmentList, storeNotes } from '../data/API'
import { apiDataStore} from '../Actions/index'
import { useSelector, useDispatch } from "react-redux";

 
function* hitProfileUpdate(body){
    try{
        const response = yield call(profileUpdate, body.payload) 
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}

function* hitMyAssignmentList(body){ 
    try{
        const response = yield call(myAssignmentList, body.payload)  
        yield put({type:MYASSIGNMENT_RECEIVE_DATA_API,  payload: response.data.assignmentList}) 
    } catch (e){
        console.log(e)
    }
}


function* hitStoreNotes(body){ 
    try{
        const response = yield call(storeNotes, body.payload)  
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}
 

export function* watchMyAssignmentApi(action) { 
    yield takeLatest(PROFILE_UPDATE_API_CALL, hitProfileUpdate)  

    yield takeLatest(MYASSIGNMENT_GET_API_CALL, hitMyAssignmentList)  

    yield takeLatest(NOTES_STORE_API_CALL, hitStoreNotes)  
}

 